<template>
  <div class="pass-form-block">
    <div class="row" v-if="Number(configuration.show_visitors_category) === 1">
      <div class="col-md-12">
        <div class="form-group"
             :class="{ 'has-error': errors.application && hasError(errors.application, 'visitors_category') }">
          <label for="form-visitors-category" class="control-label">Категория посетителей</label>
          <!--allocate to a component-->
          <select id="form-visitors-category" class="show-tick form-control"
                  v-model="application.visitors_category"
                  @change="changeVisitorsCategory"
                  :disabled="isView"
                  :title="selectedVisitorsCategoryName"
          >
            <option v-for="category in visitorCategories"
                    :key="category.id"
                    :value="Number(category.id)"
                    :title="category.name"
            >
              {{ category.name }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div class="row">
      <div :class="this.displayPurposeInput ? 'col-md-4' : 'col-md-0'">
        <pass-purpose-input
          v-model="application.application_group_purpose_id"
          :form="form"
          :errors="errors"
          :items="applicationPurposes"
          :disabled="disabledApplicationPurpose"
          @change="changePassPurpose"
        />
      </div>
      <div :class="!this.displayPurposeInput ? 'col-md-8' : 'col-md-4'">
        <terminal-region-input
          :form="form"
          :errors="errors"
          :items="terminalRegions"
          :disabled="disabledRegion"
          v-model="application.terminal_region_id"
          @change="$emit('handle-terminal-region'); change('application terminal region'); changeTerminalId($event)"
        />
      </div>
      <div class="col-md-4">
        <template v-if="needAgentCheck">
          <agent-organization-input
            :form="form"
            :errors="errors"
            :items="agentOrganizations"
            :disabled="disabledAgentOrganization"
            v-model="application.agent_organization_id"
            @change="change('application agent organization')"
          />
        </template>
        <template v-else>
          <terminal-subdivision-input
            :form="form"
            :errors="errors"
            :items="computedTerminalSubdivisions"
            :disabled="disabledSubdivision"
            v-model="application.subdivision_id"
            @change="change('application terminal subdivision')"
          />
        </template>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <period-count-input
          :form="form"
          :errors="errors"
          :items="availableTerminalTariffTimeTypes"
          :disabled="disabledPeriodCount"
          v-model="application.time_type"
          @change="changePeriodCount($event)"
        />
      </div>
      <div class="col-md-4">
        <period-of-input
          :form="form"
          :errors="errors"
          :disabled="disabledPeriodOf"
          :min-date="startDatePeriod.from"
          :max-date="startDatePeriod.to"
          :disabled-dates="startDatePeriod.disabledDates"
          v-model="application.period_of"
          @change="changePeriodOf"
        >
        </period-of-input>
      </div>
      <div class="col-md-4">
        <period-to-input
          :form="form"
          :errors="errors"
          :disabled="disabledPeriodTo || isView"
          :min-date="endDatePeriod.from"
          :max-date="endDatePeriod.to"
          :disabled-dates="endDatePeriod.disabledDates"
          v-model="application.period_to"
          @change="changePeriodTo"
        />
      </div>
    </div>
    <div class="row" v-if="showPassTimeIntervalBlock">
      <div class="col-md-4">
        <time-interval-input
          v-model="application.pass_access"
          :items="calculatedPassAccesses"
          :disabled="this.disabledInput"
          @change="changePassAccess()"
        />
      </div>
      <div class="col-md-4">
        <time-of-input
          v-model="application.time_of"
          :disabled="disablePassAccessTime || this.disabledInput"
        />
      </div>
      <div class="col-md-4">
        <time-to-input
          v-model="application.time_to"
          :disabled="disablePassAccessTime || this.disabledInput"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-4" v-if="chosenApplicationPurpose">
        <pass-kind-input
          v-model="application.pass_kind"
          :form="form"
          :errors="errors"
          :items="availablePassKinds"
          :disabled="disabledPassKinds"
          @change="changePassKind"
        />
      </div>
      <div class="col-md-4" v-if="chosenApplicationPurpose && isCurrentContractFieldsDisplay" >
        <contract-number-input
            v-model="application.contract_number"
            :form="form"
            :errors="errors"
            :disabled="this.disabledInput"
        />
      </div>
      <div class="col-md-4" v-if="chosenApplicationPurpose && isCurrentContractFieldsDisplay" >
        <contract-date-input
            :form="form"
            :errors="errors"
            :disabled="this.disabledInput"
            :max-date="currentMomentDate.clone()"
            v-model="application.contract_date"
        />
      </div>
      <div :class="!isCurrentContractFieldsDisplay ? 'col-md-8' : 'col-md-12'" v-if="needAdditionalPurpose">
        <pass-additional-purpose-input
          v-model="application.additional_purpose"
          :form="form"
          :errors="errors"
          :is-contract-fields-display="isCurrentContractFieldsDisplay"
          :disabled="disabledAdditionalPurpose"
          @change="change('application additional purpose')"
        />
      </div>
    </div>
    <tangibles-form-block
      :tangibles="form.application.tangibles"
      :form="form"
      :errors="errors"
      :application="form.application"
    >
    </tangibles-form-block>
    <div
      v-if="activity"
      class="row"
    >
      <div class="col-md-12">
        <div class="form-group">
          <label class="control-label">Вид деятельности</label>
          <div>{{ activity }}</div>
        </div>
      </div>
    </div>
    <div
      v-if="applicationPurposeCanHaveVessel && regionVesselAccess"
      class="row"
    >
      <div class="col-md-8">
        <vessel-access-input
            v-model="application.vessel_access_id"
            :form="form"
            :errors="errors"
            :items="vesselAccesses"
            :application-purposes="applicationPurposes"
            :disabled="disabledInput"
            @change="changePassKind"
        />
      </div>
      <div class="col-md-4">
        <div class="vessels-add block" v-if="!isView && canAddVessel">
          <div class="addNewVessel " id="form-vessels-button">
            <button type="button" class="btn btn-success btn-primary-white" @click="addVessel">Добавить судно
            </button>
          </div>
        </div>
      </div>
    </div>
    <vessels-form-block
      :vessels="form.vessels"
      :form="form"
      :errors="errors"
      :application="form.application"
      :personal-nationalities="personalNationalities"
      :vessel-berth-book="vesselBerthBook"
      :vessel-accesses="vesselAccesses"
      :region-vessel-access="regionVesselAccess"
      :application-purpose="applicationPurpose"
    />
    <application-documents-block
      :application="form.application"
      :applicationDocuments="calculatedApplicationDocuments"
      :form="form"
      :errors="errors"
    />
  </div>
</template>

<script>
import AgentOrganizationInput from '@/common/components/application/form-inputs/pass/AgentOrganizationInput'
import ApplicationDocumentsBlock from '@/common/components/application/ApplicationDocumentsBlock'
import applicationFormContextMixin from '@/common/mixins/applicationFormContextMixin'
import applicationFormMixin from '@/common/mixins/applicationFormMixin'
import { cloneObject, firstElement } from '@/common/helpers'
import { Logger } from '@/common/helpers/Logger'
import mainMixin from '@/common/mixins/mainMixin'
import moment from 'moment-timezone'
import passAccessMixin from '@/common/mixins/passAccessMixin'
import PassAdditionalPurposeInput from '@/common/components/application/form-inputs/pass/PassAdditionalPurposeInput'
import PassKindInput from '@/common/components/application/form-inputs/pass/PassKindInput'
import PassPurposeInput from '@/common/components/application/form-inputs/pass/PassPurposeInput'
import PeriodCountInput from '@/common/components/application/form-inputs/pass/PeriodCountInput'
import PeriodOfInput from '@/common/components/application/form-inputs/pass/PeriodOfInput'
import PeriodToInput from '@/common/components/application/form-inputs/pass/PeriodToInput'
import { PurposeNeedVesselTypes } from '@/common/enums/PurposeNeedVesselTypes'
import TangiblesFormBlock from '@/common/components/application/form-blocks/tangibles/TangiblesFormBlock'
import { TerminalRegionActions } from '@/common/enums/TerminalRegionActions'
import TerminalRegionInput from '@/common/components/application/form-inputs/pass/TerminalRegionInput'
import TerminalSubdivisionInput from '@/common/components/application/form-inputs/pass/TerminalSubdivisionInput'
import TimeIntervalInput from '@/common/components/application/form-inputs/pass/TimeIntervalInput'
import TimeOfInput from '@/common/components/application/form-inputs/pass/TimeOfInput'
import TimeToInput from '@/common/components/application/form-inputs/pass/TimeToInput'
import Transport from '@/common/classes/Transport'
import VesselsFormBlock from '@/common/components/application/form-blocks/vessels/VesselsFormBlock'
import Visitor from '@/common/classes/Visitor'
import { PassKinds } from '@/common/enums/PassKinds'
import { VesselAccesses as VesselAccessesEnum } from '@/common/enums/VesselAccesses'
import VesselAccessInput from '@/common/components/application/form-inputs/pass/VesselAccessInput.vue';
import ContractNumberInput from '@/common/components/application/form-inputs/pass/ContractNumberInput.vue';
import ContractDateInput from '@/common/components/application/form-inputs/pass/ContractDateInput.vue';
export default {
  name: 'PassFormBlock',

  components: {
    ContractDateInput,
    ContractNumberInput,
    VesselAccessInput,
    TimeToInput,
    TimeOfInput,
    TimeIntervalInput,
    PeriodCountInput,
    PeriodOfInput,
    PeriodToInput,
    PassKindInput,
    PassPurposeInput,
    TerminalRegionInput,
    AgentOrganizationInput,
    ApplicationDocumentsBlock,
    TerminalSubdivisionInput,
    PassAdditionalPurposeInput,
    VesselsFormBlock,
    TangiblesFormBlock
  },

  mixins: [
    mainMixin,
    applicationFormMixin,
    applicationFormContextMixin,
    passAccessMixin
  ],

  model: {
    prop: 'application',
    event: 'change-application'
  },

  props: {
    activityOrganizations: {
      type: [Array, Object],
      default: () => []
    },

    agentOrganizations: {
      type: [Array, Object],
      default: () => []
    },

    application: {
      type: Object,
      required: true
    },

    applicationDocuments: {
      type: Array,
      default: () => []
    },

    applicationPurposes: {
      type: [Array, Object],
      default: () => []
    },

    personalNationalities: {
      type: [Array, Object],
      default: () => []
    },

    purposeSubdivisions: {
      type: [Array, Object],
      default: () => []
    },

    passAccesses: {
      type: [Array, Object],
      default: () => []
    },

    terminalRegions: {
      type: [Array, Object],
      default: () => []
    },

    terminalSubdivisions: {
      type: [Array, Object],
      default: () => []
    },

    terminalTariffPeriods: {
      type: [Array, Object],
      default: () => []
    },

    terminalTariffTimeTypes: {
      type: [Object],
      default: () => {
      }
    },

    timezone: {
      type: String,
      default: 'Europe/Moscow'
    },

    passKinds: {
      type: [Object],
      default: () => []
    },

    vesselAccesses: {
      type: [Array, Object],
      default: () => []
    },

    vesselBerthBook: {
      type: [Array, Object],
      default: () => []
    },

    visitorCategories: {
      type: Array,
      default: () => []
    },

    visitorCategoryPurposes: {
      type: [Object, Array],
      default: () => {
      }
    }
  },

  computed: {
    activity () {
      const targetActivityOrganization = this.activityOrganizations
        .find(activityOrganization => activityOrganization.organization_inn === this.form.organization.inn)

      if (targetActivityOrganization) {
        return targetActivityOrganization.activity.name
      }

      if (this.application.application_group_purpose_id === null) {
        return
      }

      return this.applicationPurposes[this.application.application_group_purpose_id]
        ?.activities[0]
        ?.name
    },

    applicationPurpose () {
      return this.applicationPurposes[this.application.application_group_purpose_id]
    },

    applicationPurposeCanHaveVessel() {
      if (this.applicationPurpose) {
        let purpose = this.applicationPurpose

        return Number(purpose.need_vessel) !== 0
      }

      return false
    },

    applicationPurposeSubdivisions () {
      return this.purposeSubdivisions[this.application.application_group_purpose_id] ?? []
    },

    availableTerminalTariffTimeTypes () {
      if (this.applicationPurpose === undefined || this.applicationPurpose?.pass_type === 'all') {

        return this.terminalTariffTimeTypes
      } else {
        const timeType = {}
        timeType[this.applicationPurpose.pass_type] = this.terminalTariffTimeTypes[this.applicationPurpose.pass_type]
        return timeType
      }
    },

    availablePassKinds () {
      let arr = [];
      let startValues = cloneObject(this.passKinds)
      if (!this.regionAllowTransports && !this.disabledInput) {
        delete startValues.transport
      }
      this.applicationPurpose.passKinds.forEach(element => {
        if (startValues[element]) {
          arr.push(startValues[element])
        }
      })
      arr.sort(function (a, b) {
        return a.sort - b.sort;
      });
      return arr;
    },

    disabledPassKinds () {
      return this.disabledInput || this.availablePassKinds.length === 1
    },

    regionAllowTransports () {
      const conditionsForTransportPassKind = TerminalRegionActions.conditionsForTransportPassKind
      let terminalRegion = this.terminalRegions.find((region) => region.id === this.form.application.terminal_region_id)
      if (!terminalRegion) {
        return false
      }
      return conditionsForTransportPassKind[terminalRegion.transport_access]
    },

    canAddVessel () {
      return this.form.application.vessel_access_id !== VesselAccessesEnum.WITHOUT_VESSEL
    },

    calculatedApplicationDocuments () {
      return this.applicationDocuments.filter((doc) => {
        return (doc.purpose_id === this.application.application_group_purpose_id || doc.purpose_id === null) &&
          (doc.region_id === this.application.terminal_region_id || doc.region_id === null) &&
          (doc.pass_type === this.application.time_type || doc.pass_type === 'all') &&
          (doc.subject_id === this.form.organization.subject_id || doc.subject_id === null)
      })
    },

    calculatedPassAccesses () {
      const allowedAccesses = [this.application.time_type, 'all']

      return this.passAccesses.filter(
        passAccess => allowedAccesses.includes(passAccess.time_type)
      )
    },

    currentPassAccess () {
      return this.passAccesses.find((item) => parseInt(item.id) === parseInt(this.form.application.pass_access))
    },

    currentMomentDate() {
      return moment().tz(this.timezone)
    },

    showPassTimeIntervalBlock () {
      return this.calculatedPassAccesses.length > 0
    },

    computedTerminalSubdivisions () {
      if (this.isView) {
        return this.terminalSubdivisions.filter(subdivision =>
          subdivision.id === this.application.subdivision_id
        )
      }

      let subdivisionsForOrganization = this.terminalSubdivisions.filter(subdivision => {
        return this.applicationPurposeSubdivisions.find((el) => el.subdivision_id === subdivision.id && el.organization_inn === this.form.organization.inn) &&
          Number(this.application.terminal_id) === Number(subdivision.terminal_id)
      })
      if (subdivisionsForOrganization.length !== 0) {
        return subdivisionsForOrganization
      }
      return this.terminalSubdivisions.filter(subdivision => {
        return this.applicationPurposeSubdivisions.find((el) => el.subdivision_id === subdivision.id && el.organization_inn === null) &&
          Number(this.application.terminal_id) === Number(subdivision.terminal_id)
      })
    },

    disablePassAccessTime () {
      return Boolean(this.currentPassAccess.fixed) === true
    },

    chosenApplicationPurpose () {
      return this.applicationPurpose
    },

    disabledAdditionalPurpose () {
      return Boolean(
        this.disabledInput || !this.needAdditionalPurpose
      )
    },

    disabledAgentOrganization () {
      return Boolean(this.disabledInput)
    },

    disabledApplicationPurpose () {
      return Boolean(this.disabledInput) || Object.keys(this.applicationPurposes).length === 1
    },

    disabledBerth () {
      return Boolean(
        this.disabledInput ||
        !this.application.vessel ||
        Number(this.applicationPurpose?.need_vessel) === 0
      )
    },

    disabledPeriodCount () {
      return Boolean(this.disabledInput ||
        (this.applicationPurpose && this.applicationPurpose.pass_type !== 'all') ||
        Object.keys(this.availableTerminalTariffTimeTypes).length === 1)
    },

    disabledPeriodOf () {
      return Boolean(this.disabledInput)
    },

    disabledPeriodTo () {
      return this.timeType?.fixed_count_days && this.user.role !== 'supervisor'
    },

    disabledRegion () {
      return Boolean(
        this.disabledInput ||
        !this.application.application_group_purpose_id ||
        this.terminalRegions.length <= 1
      )
    },

    disabledSubdivision () {
      return Boolean(
        this.disabledInput ||
        this.computedTerminalSubdivisions.length <= 1 ||
        this.application.application_group_purpose_id === null
      )
    },

    disabledVessel () {
      return Boolean(
        this.disabledInput || Number(this.applicationPurpose?.need_vessel) === 0
      )
    },

    disabledVesselFlag () {
      return Boolean(
        this.disabledInput ||
        !this.application.vessel ||
        Number(this.applicationPurpose?.need_vessel) === 0
      )
    },

    isNeedVessel () {
      if (this.applicationPurpose) {
        return Boolean(this.applicationPurpose.need_vessel)
      } else {
        return false
      }
    },

    displayPurposeInput () {
      let visiblePurposes = (this.sortedApplicationPurposes).filter((purpose) => Number(purpose.visible) === 1)

      return (this.isCurrentPurposeVisible && visiblePurposes.length > 1) || !this.isCurrentPurposeVisible
    },

    isCurrentPurposeVisible () {
      let current = (this.sortedApplicationPurposes).find((purpose) => purpose.id === this.application.application_group_purpose_id)

      return current ? Number(current.visible) === 1 : false
    },

    isCurrentContractFieldsDisplay () {
      return Number(this.configuration.need_contract) === 1 || Number(this.configuration.need_contract) === 2
    },

    sortedApplicationPurposes () {
      return (Object.values(this.applicationPurposes).sort((a, b) => a.sort - b.sort))
    },

    needAdditionalPurpose () {
      return this.applicationPurpose?.need_additional_purpose
    },

    needType() {
      return this.applicationPurpose?.need_type
    },

    rangeTimeType () {
      const validate = !((this.user.role === 'supervisor' && this.isEdit) || this.isView)

      return validate ? this.timeType : null;
    },

    regionVesselAccess () {
      if (this.terminalRegions && this.application.terminal_region_id) {
        return Boolean(this.terminalRegions.find(region => region.id === this.application.terminal_region_id)?.vessel_access)
      } else {
        return false
      }
    },

    timeType () {
      return this.terminalTariffTimeTypes[this.form.application.time_type] ?? null
    },

    selectedVisitorsCategoryName () {
      return this.visitorCategories
        .find(x => Number(x.id) === Number(this.application.visitors_category))?.name ?? 'Категория посетителя'
    },

    terminalRegion () {
      return this.application.terminal_region_id
    },

    withoutNeedSubdivisionCheck () {
      return Boolean(this.application.application_group_purpose_id && this.applicationPurpose?.need_subdivision_check === 0)
    }
  },

  created() {
    this.setPassAccess()
  },

  watch: {
    applicationPurposeId () {
      this.changePassPurpose()
    }
  },

  mounted () {
    if (!this.isView) {
      this.changePeriodOf()
      if (this.isDuplicate || this.isDraft) {
        if (!this.computedTerminalSubdivisions?.find(s => s.id === this.application.subdivision_id)) {
          this.application.subdivision_id = null
        }
      }
    }
  },

  methods: {
    changePassAccess () {
      let currentPassAccess = this.currentPassAccess
      this.form.application.time_to = currentPassAccess.time_to
      this.form.application.time_of = currentPassAccess.time_of
    },

    changePassKind () {
      if (!this.isPassKindMaterial) {
        this.deleteTangibleBlockData()
      }
      if (this.isPassKindPedestrian) {
        this.deleteTransportBlockData()
      }
      if (this.isPassKindTransport) {
        this.deleteVisitorBlockData()
        this.addTransportBlockData()
      }
      if (this.isPassKindMaterial) {
        this.addTangibleBlockData()
      }
    },

    addTangibleBlockData () {
      if (this.form.application.tangibles.length === 0) {
        this.form.application.tangibles.push({ name: null, identification: null, count: null })
      }
    },

    addVessel () {
      let vesselAccessSetting = this.vesselAccesses.find((item) => item.id === this.form.application.vessel_access_id)
      let flag = vesselAccessSetting.is_rf === 1 ? 182 : null
      let passFlag = vesselAccessSetting.is_rf === 1 ? '/ru/terminal/vue/img/icons/countries/RU.svg' : null
      const vessel = Object.assign({}, {
        berth: null,
        flag: flag,
        name: null,
        passFlag: passFlag
      })
      this.form.vessels.push(vessel)
    },

    deleteTangibleBlockData () {
      this.form.application.tangibles = []
    },

    addTransportBlockData () {
      this.form.visitors[0].transports = [new Transport()]
    },

    deleteTransportBlockData () {
      this.form.visitors.forEach(element => {
        element.transports = []
      })
    },

    deleteVisitorBlockData () {
      this.form.visitors = [new Visitor()]
    },

    change (inputName) {
      Logger.log(`Changed ${inputName}!`)
      this.$emit('change-application', this.application)
    },

    changePassPurpose () {
      if (this.isPassKindTransport) {
        this.form.visitors[0].transports = []
      }
      if (this.isPassKindMaterial) {
        this.addTangibleBlockData()
      }
      if (!this.isPassKindMaterial) {
        this.deleteTangibleBlockData()
      }

      const timeType = this.applicationPurpose?.pass_type

      if (timeType !== undefined && timeType !== 'all') {
        this.$set(this.application, 'time_type', this.applicationPurpose.pass_type)
        this.changePeriodCount(timeType)
      }

      if (this.application.application_group_purpose_id) {
        this.application.subdivision_id = null
        this.application.terminal_region_id = null
      }

      if (this.applicationPurpose?.need_terminal) {
        this.application.additional_terminal_region = ''
      } else {
        this.application.terminal_region_id =
          this.applicationPurpose?.terminal_region
      }

      this.application.need_additional_purpose = this.applicationPurpose?.need_additional_purpose
      this.application.need_type = this.applicationPurpose?.need_type
      switch (this.applicationPurpose?.need_vessel) {
        case PurposeNeedVesselTypes.FORBIDDEN_VESSEL:
          this.form.application.vessel_access_id = VesselAccessesEnum.WITHOUT_VESSEL
          break
        case PurposeNeedVesselTypes.FREE_VESSEL:
          this.form.application.vessel_access_id = (this.vesselAccesses.filter((item) => Number(item.visible) === 1))[0].id
          break
        case PurposeNeedVesselTypes.NEED_VESSEL:
          this.form.application.vessel_access_id = (this.vesselAccesses.filter((item) => Number(item.visible) === 1 && item.id !== VesselAccessesEnum.WITHOUT_VESSEL))[0].id
          break
        default:
          this.form.application.vessel_access_id = VesselAccessesEnum.WITHOUT_VESSEL
      }

      this.application.need_agent_check = this.applicationPurpose?.need_agent_check

      if (Number(this.form.application.need_agent_check) === 0) {
        this.application.agent_organization_id = null
      }

      if (this.application.vessel_access_id === VesselAccessesEnum.WITHOUT_VESSEL || !this.regionVesselAccess) {
        this.form.vessels = []
      }

      this.form.tangibles = []

      this.$nextTick(() => {
        if (this.terminalRegions.length === 1) {
          const terminalRegion = firstElement(this.terminalRegions)
          this.application.terminal_region_id = terminalRegion.id
          this.changeTerminalId(terminalRegion.id)
          this.$emit('handle-terminal-region')
        }
      })
    },

    changePeriodCount (value) {
      this.application.period_count = this.terminalTariffTimeTypes[value]?.period_count ?? 1
      this.setPassAccess()
      this.emitChangeDate()

      if (!this.application.application_group_purpose_id) {
        this.application.application_group_purpose_id = null
        this.application.terminal_region_id = null
      }
    },

    changePeriodOf (periodOf) {
      if (typeof periodOf === 'string' || periodOf instanceof String) {
        this.setPeriodOf(moment.tz(periodOf, 'DD.MM.YYYY', this.timezone))
      }
      this.emitChangeDate(true)
    },

    changePeriodTo (periodTo) {
      if (typeof periodTo === 'string' || periodTo instanceof String) {
        this.setPeriodTo(moment.tz(periodTo, 'DD.MM.YYYY', this.timezone))
      }
      this.emitChangeDate(true)
    },

    changeTerminalId (event) {
      this.$set(this.application, 'terminal_id', this.terminalRegions.find((x) => parseInt(x.id) === parseInt(event))?.terminal_id)
    },

    changeVisitorsCategory () {
      this.$nextTick().then(() => {
        this.application.application_group_purpose_id = Number(Object.keys(this.applicationPurposes)[0])
        this.$nextTick().then(() => {
          if (this.terminalRegions.length === 1) {
            this.application.terminal_region_id = this.terminalRegions[0].id
          }
          this.$nextTick().then(() => {
            if (this.terminalSubdivisions.length === 1) {
              this.application.subdivision_id = this.terminalSubdivisions[0].id
            }

            this.$emit('handle-terminal-region')
          })
        })
      })
    },

    emitChangeDate () {
      this.$emit('change-date', ...arguments)
    }
  }
}
</script>
